<template lang="pug">
	div
		nuxt
</template>

<script>
export default {

	data(){
		return{
		}
	}
}
</script>
